import { Component, OnInit, OnDestroy, Inject, Output, EventEmitter, Input, Optional } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';
import { stemsEQModel } from 'src/app/models/magic-search.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { MagicSearchService } from 'src/app/services/magic-search/magic-search.service';
import { DEFAULT_STEMS } from 'src/app/constants/magic-search.constants';

@Component({
  selector: 'ipm-filter-beat',
  templateUrl: './filter-beat.component.html',
  styleUrls: ['./filter-beat.component.scss']
})
export class FilterBeatComponent implements OnInit, OnDestroy {
  filterOptionList:  Array<FilterListModel> = [];
  selectedSort: any = {};
  @Output() emitSortFilter: EventEmitter<any> = new EventEmitter();
  @Input() isComponentType: any = "";
  @Input() geneFilterList: Array<any> = [];
  @Input() activeTabIndex: number = 0;
  searchQueries: { [index: number]: string } = {};
  mobileStems: stemsEQModel = { ...DEFAULT_STEMS, levels: { ...DEFAULT_STEMS.levels } };
  mobileEqEnabled = true;
  private stemsEqSubscription: Subscription;
   constructor( private commonService: CommonService,
    public formService: FormsService,
    private browserStorage: BrowserStorageService,
    private ga4Tracking: Ga4trackingService,
    public magicSearchService: MagicSearchService,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router) {}
   ngOnInit(): void {
    if (this.isComponentType === 'magic') {
      this.stemsEqSubscription = this.magicSearchService.stemsEq$.subscribe(({ stems, eqEnabled }) => {
        this.mobileStems = stems;
        this.mobileEqEnabled = eqEnabled;
      });
    }
    if (this.data?.filterList) {
      // Pre-select a specific tab if the caller passed an index
      if (this.data.activeTabIndex != null) {
        this.activeTabIndex = this.data.activeTabIndex;
      }
      if (this.isComponentType === 'playlist')  {
        let filterOptionListTemp: any =  this.data.filterList;
        filterOptionListTemp.map((filterObj: any) => {
          if (filterObj.ApiFilterKey !== "categories" && filterObj.ApiFilterKey !== 'price' && filterObj.ApiFilterKey !== "sort") {
            this.filterOptionList.push(filterObj);
          }
        })
      } else {
        this.filterOptionList =  this.data.filterList;
      }
      this.commonService.sortFilter.subscribe((res: any) => {
        if (Object.keys(res).length) {
          this.selectedSort = res;
          this.filterOptionList =  this.filterOptionList.filter((filterData: FilterListModel) => {
            if (filterData.filter_type === 'sort_menu') {
                let foundList = filterData.filter_sub_list.filter( item =>  item.key === res.key);
                if (foundList && foundList.length > 0) {
                  filterData.filter_selected_values =  foundList;
                }
            }
            return filterData;
          });
        }
      });
      this.setFilterValues();
    }
   }

  ngOnDestroy(): void {
    this.stemsEqSubscription?.unsubscribe();
  }

  closeDialog() {
    this.commonService.closePopUp();
  }

  /**
   * in this function update the value of filter
   * which data is selected
   */
  setFilterValues() {
    this.filterOptionList.map((filterObj: FilterListModel)  => {
      let selectedFilter: Array<FilterSubsListObj> = filterObj.filter_selected_values
      if (selectedFilter.length) {
        selectedFilter.map( selectedFilObj => {
          filterObj.filter_sub_list.filter( item =>  {
            if(selectedFilObj.key === item.key) {
              item.isSelected = true;
            }
          })
        })
      }
    })

  }

  /**
   * apply the filter
   */
  applyFilter() {
    this.commonService.sortFilter.subscribe((res: any) => {
      let eventname = 'ipm_filter_apply_moblie';
      let attributes = {

        'category': 'filter',

        'action': 'click',
        'label': 'apply_filter',
        userId : this.browserStorage.getUserId() ? this.browserStorage.getUserId() : '0',
        userRole : this.browserStorage.getCurrentRoles() ? this.browserStorage.getCurrentRoles() : '0',
      };
      this.ga4Tracking.sendEvent(eventname, attributes);
      if (Object.keys(res).length) {
          if (res.key !==  this.selectedSort.key) {
            this.emitSortFilter.emit(this.selectedSort);
          }
      }
    }).unsubscribe();
    
    if (this.isComponentType !== 'magic') {
      this.commonService.sendSearchDataUrl('', 'filter', this.isComponentType);
    }
  }

  /**
   * in this function reset the
   * all filters
   */
  resetFilter() {
    this.commonService.resetFilter();
    this.router.navigate([]);
  }

  /**
   * Apply button — branches for Magic since its filter list never touches the
   * global commonService.filterOptionList/URL pipeline that Classic relies on.
   */
  apply(): void {
    this.applyFilter();
    if (this.isComponentType === 'magic') {
      this.magicSearchService.triggerFiltersAppliedFromMobile();
    }
    this.commonService.closePopUp();
  }

  /**
   * Clear Filter link — Magic resets its local filterOptionList entries in place;
   * Classic keeps its existing global reset + URL nav.
   */
  clear(): void {
    if (this.isComponentType === 'magic') {
      this.clearMagicFilters();
      this.magicSearchService.triggerFiltersAppliedFromMobile();
      this.magicSearchService.requestClearQueryText();
    } else {
      this.resetFilter();
    }
    this.commonService.closePopUp();
  }

  private clearMagicFilters(): void {
    this.filterOptionList.forEach((filterObj: FilterListModel) => {
      if (filterObj.filter_type === 'multiselect') {
        filterObj.filter_selected_values = [];
        filterObj.filter_sub_list.forEach(option => option.isSelected = false);
      } else if (filterObj.filter_type === 'menu') {
        const max = filterObj.ApiFilterKey === 'tempo' ? '500' : '100000';
        filterObj.filter_sub_list[0].starting_range = '0';
        filterObj.filter_sub_list[0].end_range = max;
        filterObj.filter_selected_values[0] = { ...filterObj.filter_sub_list[0] };
        filterObj.isFilterApplied = false;
      }
    });
  }

  isSingleSelected(parentIndex: number, key: string | undefined): boolean {
    return this.filterOptionList[parentIndex]?.filter_selected_values?.[0]?.key === key;
  }

  onSingleSelectClick(parentIndex: number, sub: FilterSubsListObj): void {
    const filterItem = this.filterOptionList[parentIndex];
    const alreadySelected = filterItem.filter_selected_values?.[0]?.key === sub.key;
    filterItem.filter_selected_values = alreadySelected ? [] : [sub];
    this.onchangeEventInput(parentIndex);
  }

  // Which price type (mp3/wav/stem/exclusive) the Price range filter applies to —
  // mirrors the desktop selector in filter-section.component.ts.
  priceTypeOptions: Array<{ key: string, label: string }> = [
    { key: 'mp3', label: 'MP3' },
    { key: 'wav', label: 'WAV' },
    { key: 'stem', label: 'Stems' },
    { key: 'exclusive', label: 'Exclusive' },
  ];

  onPriceTypeChange(filterData: FilterListModel, type: string): void {
    filterData.selectedPriceType = type;
  }

  onMobileStemsChange(stems: stemsEQModel): void {
    this.magicSearchService.setStemsEq(stems, this.mobileEqEnabled);
  }

  onMobileEqEnabledChange(enabled: boolean): void {
    this.magicSearchService.setStemsEq(this.mobileStems, enabled);
  }

  onchangeEventInput(parentIndex: number) {
    let filterItem =  this.filterOptionList[parentIndex];
    if (filterItem && filterItem?.filter_type === 'sort_menu') {
          let foundIndex =  filterItem.filter_selected_values.findIndex( item =>  item.key === this.selectedSort.key);
          if (foundIndex > -1) {
            filterItem.filter_selected_values.splice(foundIndex, 1);
            if (filterItem.filter_selected_values.length > 0) {
              const sortKey = filterItem.filter_selected_values[0].key ?? '';
              const sortIdMap: Record<string, string> = {
                price_desc: '1', price_asc: '2', one_scroll_algo: '3', recent_beats: '4'
              };
              let sendData: any = {
                name:filterItem.filter_selected_values[0].value,
                id: sortIdMap[sortKey] ?? '3',
                key: sortKey
              }
              this.selectedSort = sendData;
            }
            this.filterOptionList[parentIndex] = filterItem;
          }
    } else {
      this.filterOptionList[parentIndex] = filterItem;
    }
  }
}
